import { colors } from '../../colors';
var fiftyFiftyCard = {
  bgColorLight: colors.white,
  bgColorDark: colors.graphite,
  textColorDark: colors.graphite,
  textColorLight: colors.white,
  cardRadius: '20px'
};
export default fiftyFiftyCard;